import { Button } from '@/components/ui/Button';
import { ACTION_LABEL, useErrorAction } from '@/hooks/useErrorAction';
import { useUiStore } from '@/store/ui';
import { errorCatalog } from '@shared/errors';

/**
 * `ErrorBanner` —— 消费 `ui` store 的 `globalError`，渲染**驻留**横幅（人话文案 + 可执行动作 + ✕）。
 *
 * 与 Toast 的分工：Toast = 瞬态（数秒自动消失）；ErrorBanner = 驻留（链路级/阻塞性错误，
 * 需用户显式处理，或由系统恢复信号 `clearGlobalError()` 清除）。挂载见 `Layout/AppShell.tsx`。
 */
export function ErrorBanner(): JSX.Element | null {
  const code = useUiStore((s) => s.globalError);
  const clear = useUiStore((s) => s.clearGlobalError);
  const resolve = useErrorAction();

  if (!code) return null;
  const entry = errorCatalog[code] ?? errorCatalog.E_UNKNOWN;
  const handler = entry.action !== 'none' ? resolve(entry.action) : null;

  return (
    <div
      role="alert"
      className="flex items-center justify-between gap-3 border-b border-err/40 bg-err/15 px-4 py-2 text-sm text-err"
    >
      <span className="min-w-0 break-words">{entry.text}</span>
      <div className="flex shrink-0 items-center gap-2">
        {handler ? (
          <Button variant="ghost" size="sm" onClick={handler}>
            {ACTION_LABEL[entry.action]}
          </Button>
        ) : null}
        <button
          type="button"
          aria-label="关闭错误提示"
          className="shrink-0 text-dim hover:text-text"
          onClick={clear}
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default ErrorBanner;
